var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup19937(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3135 13.6658C10.6702 13.0389 7.88545 13.656 5.75445 15.3408C3.62346 17.0256 2.38057 19.5929 2.38075 22.3095C2.38078 22.6907 2.07171 22.9999 1.69042 22.9999C1.30914 22.9999 1.00003 22.6908 1 22.3096C0.999785 19.1707 2.43587 16.2044 4.89811 14.2576C7.36019 12.3111 10.5776 11.598 13.6315 12.3221C13.8972 12.3847 14.1607 12.4563 14.4275 12.5453C14.7892 12.6658 14.9847 13.0568 14.8642 13.4185C14.7436 13.7803 14.3526 13.9757 13.9909 13.8552C13.7719 13.7822 13.5496 13.7213 13.3147 13.6661L13.3135 13.6658Z",
    fill: "#3D5A80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2636 2.38075C8.79801 2.38075 6.79921 4.37955 6.79921 6.84519C6.79921 9.31083 8.79801 11.3096 11.2636 11.3096C13.7293 11.3096 15.7281 9.31083 15.7281 6.84519C15.7281 4.37955 13.7293 2.38075 11.2636 2.38075ZM5.41846 6.84519C5.41846 3.61698 8.03544 1 11.2636 1C14.4919 1 17.1088 3.61698 17.1088 6.84519C17.1088 10.0734 14.4919 12.6904 11.2636 12.6904C8.03544 12.6904 5.41846 10.0734 5.41846 6.84519Z",
    fill: "#3D5A80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.937 22.1276V18.6274H19.3178V22.1276H17.937Z",
    fill: "#3D5A80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2554 16.3725C14.2554 15.6099 14.8736 14.9917 15.6361 14.9917H21.6194C22.382 14.9917 23.0001 15.6099 23.0001 16.3725V21.6193C23.0001 22.3819 22.382 23.0001 21.6194 23.0001H15.6361C14.8736 23.0001 14.2554 22.3819 14.2554 21.6193V16.3725ZM21.6194 16.3725L15.6361 16.3725V21.6193H21.6194L21.6194 16.3725Z",
    fill: "#3D5A80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.78551 7.31068L8.05957 5.58474L9.03591 4.6084L10.7619 6.33434L9.78551 7.31068Z",
    fill: "#3D5A80"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8336 7.31068L14.5596 5.58474L13.5832 4.6084L11.8573 6.33434L12.8336 7.31068Z",
    fill: "#3D5A80"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup19937);
export default __webpack_public_path__ + "static/media/Group 19937.697195a9f24f262e6f520a8c72519b61.svg";
export { ForwardRef as ReactComponent };